/**
 * Mengubah pilihan cabang tanpa menduplikasi ID atau menghapus pilihan lain.
 * Helper murni ini dipakai oleh form tambah dan ubah produk.
 */
export function updateSelectedBranchIds(
  currentIds: string[],
  branchId: string,
  selected: boolean,
): string[] {
  const normalizedId = branchId.trim();
  if (!normalizedId) return [...currentIds];
  if (selected) {
    return currentIds.includes(normalizedId)
      ? [...currentIds]
      : [...currentIds, normalizedId];
  }
  return currentIds.filter((id) => id !== normalizedId);
}
